export default {"src":"/seller-forums/_next/static/media/amazonRepliedBadge.7a1f99b7.svg","height":20,"width":20};